/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Services_Learn_MoreInputs */

const en_home_services_learn_more = /** @type {(inputs: Home_Services_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn More`)
};

const fr_home_services_learn_more = /** @type {(inputs: Home_Services_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En savoir plus`)
};

/**
* | output |
* | --- |
* | "Learn More" |
*
* @param {Home_Services_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_services_learn_more = /** @type {((inputs?: Home_Services_Learn_MoreInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Services_Learn_MoreInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_services_learn_more(inputs)
	return fr_home_services_learn_more(inputs)
});